import { OptimizelyDecision } from '@optimizely/react-sdk';

export const CATALOG_MAINTENANCE_PAGE = 'catalog_maintenance_page';
export const DISCOVER_AI_TAB = 'catalog_discover_ai';
export const NOTIFY_ME_WHEN = 'notify_me_when';
export const ONE_FRONT_DOOR = 'home_funding_milestone';
export const PROGRAM_COST = 'catalog_program_costs';
export const PROGRAM_RECS = 'program_recommendations';
export const QUIZ_SCREEN_ORDER = 'catalog_quiz_order';
export const ROLE_MAPPING = 'catalog_role_mapping';
export const LIMITED_CATALOG = 'limited_catalog';
export const WFM_INTERNATIONAL = 'wfm_international';
export const NEW_FILTERS = 'new_catalog_filters';

export const HIDE_TUITION_WHEN_NO_OUT_OF_POCKET = 'on_hide_tuition_when_no_out_of_pocket';

export enum RoleVariaions {
	GENERIC = 'generic',
	SPECIFIC = 'specific',
	DESTINATION = 'destination',
}

export const getRolesToDisplay = (decision: OptimizelyDecision): RoleVariaions | null => {
	if (decision.enabled && decision.variationKey === 'on_ep_verified_role_titles') {
		return RoleVariaions.SPECIFIC;
	}
	if (decision.enabled && decision.variationKey === 'on_generic_role_titles') {
		return RoleVariaions.GENERIC;
	}
	if (decision.enabled && decision.variationKey === 'on_destination_role_titles') {
		return RoleVariaions.DESTINATION;
	}
	return null;
};
